import { InputAdornment, OutlinedInput, styled } from '@mui/material';

export const OutlinedInputStyled = styled(OutlinedInput)(({ theme }) => ({
  height: `${theme.customSizes.inputHeight}rem`,
  backgroundColor: theme.palette.common.white,

  '& .MuiOutlinedInput-input': {
    ...theme.typography.body1,
    color: theme.palette.primaryDark.main,
    padding: theme.spacing(2, 3),
    WebkitTextFillColor: theme.palette.primaryDark.main,

    '&::placeholder': {
      color: theme.palette.grey[400],
      WebkitTextFillColor: theme.palette.grey[400],
    },
  },

  '& .MuiInputAdornment-root': {
    color: theme.palette.grey[400],
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: `0.1rem solid ${theme.palette.grey[400]}`,
  },

  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: `0.2rem solid ${theme.palette.primary.main}`,
  },

  '&.Mui-disabled': {
    backgroundColor: theme.palette.grey[200],
  },

  '&.Mui-error .MuiOutlinedInput-notchedOutline': {
    border: `0.1rem solid ${theme.palette.error.main}`,
  },

  '&.Mui-error .MuiOutlinedInput-input': {
    color: theme.palette.grey[400],
    WebkitTextFillColor: theme.palette.grey[400],
  },
}));

export const InputAdornmentStyled = styled(InputAdornment)({
  '& .MuiSvgIcon-root': {
    fontSize: '1.5rem',
  },
});

export const PlaceholderStyled = styled('div')(({ theme }) => ({
  WebkitTextFillColor: theme.palette.grey[300],
}));
